import { apiAuth } from '../api'
import { AuthLogoutService, LogoutReason, UserType } from '../lib/AuthLogoutService'

export const sendUserVerificationEmail = (email: string, institutionId: number) => {
  return apiAuth.sendVerificationEmail({ email, institutionId })
}

export const logoutUser = async (source = 'entities.auth.profile'): Promise<void> => {
  await AuthLogoutService.logout({
    reason: LogoutReason.USER_INITIATED,
    userType: UserType.REGULAR,
    metadata: {
      source,
      timestamp: Date.now(),
    },
  })
}
